import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-tabs-wrapper',
  styles: [
    `
      .tabs {
        margin-bottom: 24px;
        margin-top: 24px;
      }

      button {
        background-color: transparent;
        border: none;
        padding: 8px 16px;
        border-bottom: 1px solid #c6c6c8;
        color: #858585;
        font-weight: 600;
      }

      button.active {
        color: #333;
        border-color: #000;
      }
    `,
  ],
  template: `
    <div class="tabs-wrapper">
      <h3 class="title">{{ props['title'] }}</h3>
      <div class="tabs">
        <button
          *ngFor="let tab of visibleFieldGroups; let i = index"
          type="button"
          [class.active]="i === activeTab"
          (click)="setActive(i)">
          {{ tab.props['label'] }}
        </button>
      </div>

      <div class="tab-content">
        <formly-field
          *ngFor="let field of visibleFieldGroups?.[activeTab]?.fieldGroup"
          [field]="field">
        </formly-field>
      </div>
    </div>
  `,
  standalone: true,
  imports: [FormlyModule, CommonModule],
})
export class TabsWrapperComponent extends FieldWrapper implements OnInit {
  activeTab = 0;

  public ngOnInit(): void {
    this.setActive(this.getTabIndex());
  }

  public get visibleFieldGroups() {
    return this.field?.fieldGroup?.filter((fieldGroup: any) => {
      return !fieldGroup?.hideExpression?.(this.field);
    });
  }

  public setActive(index: number) {
    this.activeTab = index;
    const selectedTabField =
      this.visibleFieldGroups[index].props['selectedTabField'];
    if (selectedTabField) {
      this.field.parent.form
        .get(selectedTabField)
        .setValue(this.visibleFieldGroups[index].props['tabName']);
    }
  }

  private getTabIndex(): number {
    const selectedTabField =
      this.visibleFieldGroups[0].props['selectedTabField'];
    if (selectedTabField) {
      const value = this.field.parent.form.get(selectedTabField).value;
      const index = this.visibleFieldGroups.findIndex((fieldGroup: any) => {
        return fieldGroup.props.tabName === value;
      });
      return index && index >= 0 ? index : 0;
    } else {
      return 0;
    }
  }
}
